module.exports = __webpack_public_path__ + "static/media/pencil-square.16d65b16.svg";